// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__Dt_Yo","info":"UpdateTermsInfo_info__1OJqT"};